var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimeline01 = function SvgTimeline01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 64.24,
    y1: 232.62,
    x2: 225.93,
    y2: 78.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 19.2,
    y1: 185.33,
    x2: 180.9,
    y2: 31.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1.5,
    y1: 163.58,
    x2: 160.19,
    y2: 9.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 20.72,
    y1: 186.92,
    x2: 182.42,
    y2: 32.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 42.82,
    y1: 210.13,
    x2: 204.52,
    y2: 56.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 19.91,
    y1: 186.07,
    x2: 181.61,
    y2: 32.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 42.14,
    y1: 209.41,
    x2: 203.83,
    y2: 55.43,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M158.86,138.6h-26.16c-1.81,0-3.29,1.47-3.29,3.29v26.16c0,1.81,1.47,3.29,3.29,3.29h26.16c1.81,0,3.29-1.47,3.29-3.29v-26.16c0-1.81-1.47-3.29-3.29-3.29ZM155.58,164.77h-19.59v-19.59h19.59v19.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.03,18.56h-5.48v-6.04c0-7.1-5.78-12.88-12.88-12.88h-3.95c-7.1,0-12.88,5.78-12.88,12.88v6.04H61.41v-6.04c0-7.1-5.78-12.88-12.88-12.88h-3.95c-7.1,0-12.88,5.78-12.88,12.88v6.04h-5.11C11.55,18.56-.69,30.79-.69,45.84v126.42c0,15.04,12.24,27.28,27.28,27.28h145.44c15.04,0,27.28-12.24,27.28-27.28V45.84c0-15.04-12.24-27.28-27.28-27.28ZM143.4,12.52c0-3.48,2.83-6.3,6.3-6.3h3.96c3.48,0,6.3,2.83,6.3,6.3v20.56c0,3.48-2.83,6.3-6.3,6.3h-3.96c-3.48,0-6.3-2.83-6.3-6.3V12.52ZM38.26,12.52c0-3.48,2.83-6.3,6.3-6.3h3.96c3.48,0,6.3,2.83,6.3,6.3v20.56c0,3.48-2.83,6.3-6.3,6.3h-3.96c-3.48,0-6.3-2.83-6.3-6.3V12.52ZM172.03,192.97H26.58c-11.42,0-20.71-9.29-20.71-20.71v-92.97h186.86v92.96h.01c0,11.43-9.29,20.72-20.71,20.72ZM192.76,72.73H5.88v-26.89c0-11.42,9.29-20.71,20.71-20.71h5.11v7.94c0,7.1,5.78,12.88,12.88,12.88h3.96c7.1,0,12.88-5.78,12.88-12.88v-7.94h75.43v7.94c0,7.1,5.78,12.88,12.88,12.88h3.96c7.1,0,12.88-5.78,12.88-12.88v-7.94h5.48c11.42,0,20.71,9.29,20.71,20.71v26.89Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.66,95.72h-26.16c-1.81,0-3.29,1.47-3.29,3.29v26.16c0,1.81,1.47,3.29,3.29,3.29h26.16c1.81,0,3.29-1.47,3.29-3.29v-26.16c0-1.81-1.47-3.29-3.29-3.29ZM62.38,121.89h-19.59v-19.59h19.59v19.59Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.39,95.72h-26.16c-1.81,0-3.29,1.47-3.29,3.29v26.16c0,1.81,1.47,3.29,3.29,3.29h26.16c1.81,0,3.29-1.47,3.29-3.29v-26.16c0-1.81-1.47-3.29-3.29-3.29ZM109.1,121.89h-19.59v-19.59h19.59v19.59Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.86,95.72h-26.16c-1.81,0-3.29,1.47-3.29,3.29v26.16c0,1.81,1.47,3.29,3.29,3.29h26.16c1.81,0,3.29-1.47,3.29-3.29v-26.16c0-1.81-1.47-3.29-3.29-3.29ZM155.58,121.89h-19.59v-19.59h19.59v19.59Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65.66,138.6h-26.16c-1.81,0-3.29,1.47-3.29,3.29v26.16c0,1.81,1.47,3.29,3.29,3.29h26.16c1.81,0,3.29-1.47,3.29-3.29v-26.16c0-1.81-1.47-3.29-3.29-3.29ZM62.38,164.77h-19.59v-19.59h19.59v19.59Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M112.39,138.6h-26.16c-1.81,0-3.29,1.47-3.29,3.29v26.16c0,1.81,1.47,3.29,3.29,3.29h26.16c1.81,0,3.29-1.47,3.29-3.29v-26.16c0-1.81-1.47-3.29-3.29-3.29ZM109.1,164.77h-19.59v-19.59h19.59v19.59Z"
  })));
};
export default SvgTimeline01;